import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PlaycastAnalyticsAffiliateLinkHit, sendAnalytics } from '@playcastdotio/Analytics';
import { getPersistentPlayerId } from '../../api';
import { authStore } from '../../api/stores/globalStores';
import { usePavilion } from '../contexts/PavilionContext';

export const Affiliate = () => {
  const { affiliate } = useParams();
  const { isPavilionMode } = usePavilion();
  const navigate = useNavigate();
  const sentToGa = useRef(false);

  useEffect(() => {
    if (affiliate && !sentToGa.current) {
      sendAnalytics({
        name: 'Affiliate Link Hit',
        role: 'player',
        affiliate: affiliate,
        persistentId: getPersistentPlayerId(),
        playerAuthId: authStore.currentState.playerAuthId,
      } as PlaycastAnalyticsAffiliateLinkHit);

      // Prevent duplicate events
      sentToGa.current = true;

      if (isPavilionMode) {
        // Use React Router navigation when in Pavilion mode
        navigate(`/affiliate-welcome/${affiliate}`);
      } else {
        // Redirect to Pavilion domain when not in Pavilion mode
        window.location.href = `https://pavilion.playcast.io/a/${affiliate}`;
      }
    }
  }, [affiliate, isPavilionMode, navigate]);

  return null;
};
